import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _get from 'lodash/get';

import './field-radio.scss';

class FieldRadio extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const { field, onChange } = this.props;

        if (onChange && typeof onChange === 'function') {
            onChange(event);
        }

        if (field && field.onChange && typeof field.onChange === 'function') {
            field.onChange(event);
        }
    }

    render() {
        const {
            appearance,
            className,
            form,
            id,
            field,
            label,
            value,
            ariaLabelledby,
            selectedOption,
            ...other
        } = this.props;
        const fieldName = field.name;
        const fieldId = id || fieldName;
        const error = _get(form.errors, fieldName);
        const isInvalid = error !== undefined && error !== null;
        const isTouched = !!_get(form.touched, fieldName);
        const isSelected = (!!field.value && field.value === value) || selectedOption === value;
        const radioClassName = classNames('field-radio', {
            'field-radio--invalid': isTouched && isInvalid,
            'field-radio--selected': isSelected,
            [`field-radio--${appearance}`]: true,
        }, className);
        const ariaProps = {};

        if (ariaLabelledby) {
            ariaProps['aria-labelledby'] = ariaLabelledby;
        }

        return (
            <div className={radioClassName}>
                <input
                    className="field-radio__input"
                    id={fieldId}
                    {...field}
                    {...other}
                    {...ariaProps}
                    checked={isSelected}
                    onChange={this.handleChange}
                    value={value}
                    type="radio"
                />
                <label
                    className="field-radio__label"
                    htmlFor={fieldId}
                >
                    <span aria-hidden="true" className="field-radio__indicator" />
                    {label}
                </label>
            </div>
        );
    }
}

FieldRadio.propTypes = {
    appearance: PropTypes.oneOf([
        'default',
        'button',
    ]),
    className: PropTypes.string,
    field: PropTypes.shape({
        name: PropTypes.string,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        value: PropTypes.string,
    }),
    form: PropTypes.shape({
        errors: PropTypes.objectOf(PropTypes.oneOfType([
            PropTypes.shape({}),
            PropTypes.string,
        ])),
        touched: PropTypes.objectOf(PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.shape({}),
        ])),
    }),
    id: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]).isRequired,
    ariaLabelledby: PropTypes.string,
    selectedOption: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
};

FieldRadio.defaultProps = {
    appearance: 'default',
    className: '',
    id: '',
    label: '',
    onChange: () => { },
    ariaLabelledby: '',
    field: {},
    form: {},
    selectedOption: '',
};

export default FieldRadio;
